var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1043 80.7333L54.1508 65.7143H28.0689L24.0056 80.7333H0.175049L26.3667 0.266602H55.3039L81.8251 80.7333H58.1043ZM49.6483 47.9546L46.189 34.7993C45.8229 33.3741 45.2921 31.346 44.5966 28.715C43.9011 26.0474 43.2056 23.3067 42.5101 20.4929C41.8511 17.6426 41.3387 15.3039 40.9726 13.4767C40.6431 15.3039 40.1673 17.5695 39.545 20.2736C38.9593 22.9412 38.337 25.5906 37.678 28.2216C37.0557 30.8527 36.5066 33.0453 36.0308 34.7993L32.5715 47.9546H49.6483Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.7a44a8d3a8b69838c9176c7fb7d9ada8.svg";
export { ForwardRef as ReactComponent };